import { css } from 'linaria';

export const ceilingsTypesCardGrid = css`
  && {
    @media (--from-desktop) {
      column-gap: 32px;
    }

    @media (--only-mobile) {
      grid-template-rows: repeat(2, auto);
      row-gap: 32px;
    }
  }
`;

export const ceilingsTypesCardImage = css`
  && {
    @media (--from-desktop) {
      object-fit: contain;
    }

    @media (--only-tablet) {
      min-height: 192px;
    }

    @media (--only-mobile) {
      min-height: 160px;
    }
  }
`;

export const ceilingsTypesCardContent = css`
  && {
    padding: 32px;

    @media (--only-mobile) {
      padding: 32px 16px;
    }
  }
`;

export const ceilingsTypesCardTitle = css`
  && {
    margin-bottom: 16px;
  }
`;

export const ceilingsTypesCardDescriptionList = css`
  && {
    margin-bottom: 32px;

    li {
      align-items: flex-start;
      column-gap: 12px;
    }

    li:not(:last-child) {
      margin-bottom: 16px;

      @media (--only-tablet) {
        min-height: 48px;
      }
    }

    li:nth-of-type(4) {
      @media (--only-desktop) {
        min-height: 48px;
      }
    }
  }
`;

export const ceilingsTypesCardButton = css`
  && {
    @media (--only-mobile) {
      width: 100%;
    }
  }
`;
